export const termsOfUseHtml = `
<div style="text-align:left;font-family:Arial, sans-serif;line-height:1.6;color:#333;">
  <p><strong>Last Updated:</strong> October 31, 2025</p>

  <h3>1. Introduction</h3>
  <p>Welcome to Miracle Pace Inc. ("Miracle Pace," "we," "our," or "us"). These Terms of Use ("Terms") govern your access to and use of our website, mobile application, and all related services (collectively, the "Platform"). By accessing or using the Platform, you agree to comply with and be bound by these Terms. If you do not agree, please do not use the Platform.</p>

  <h3>2. Eligibility</h3>
  <ul>
    <li>Be at least 18 years old (or the age of majority in your jurisdiction),</li>
    <li>Have full legal capacity to enter into binding agreements, and</li>
    <li>Use the Platform only for lawful purposes in compliance with applicable laws and regulations.</li>
  </ul>

  <h3>3. Our Services</h3>
  <p>Miracle Pace provides currency exchange and payment-related services ("Services"). We may also provide related tools, analytics, and integrations to facilitate transactions. We reserve the right to update, suspend, or discontinue any aspect of the Services at any time without prior notice.</p>

  <h3>4. Account Registration</h3>
  <p>You may need to create an account to use certain features. You agree to provide accurate information, maintain confidentiality of login credentials, and notify us of unauthorized use.</p>

  <h3>5. User Responsibilities</h3>
  <p>You agree not to use the Platform for fraudulent, illegal, or abusive activity, interfere with its operation, access data not intended for you, or use automated tools without permission.</p>

  <h3>6. Fees and Payments</h3>
  <p>All applicable fees and transaction costs will be disclosed prior to execution. You authorize Miracle Pace and its partners (Stripe, etc.) to process payments.</p>

  <h3>7. Exchange Rates & Fees</h3>
  <ul>
    <li>The displayed exchange rate is for reference only. The actual settlement rate may be slightly adjusted to include platform fees. Stripe processing fees are paid by the customer. The final amount you pay may vary slightly due to market exchange rates and platform adjustments.</li>
    <li>By confirming a transaction, you acknowledge and accept that the actual amount paid may differ slightly from the displayed rate.</li>
    <li>The platform shall not be held responsible for any differences in amount arising from market fluctuations, payment channel fees, or other objective factors. The platform guarantees only that transactions will be completed at the settled amount.</li>
    <li>By registering or using the platform, you confirm that you have read and agreed to these terms and acknowledge the above rules.</li>
  </ul>

  <h3>Transaction Confirmation Prompt</h3>
  <p>"Please note: Stripe processing fees are paid by you. The final amount may vary slightly due to platform adjustments and exchange rates."</p>

  <h3>8. Third-Party Services</h3>
  <p>Our Platform integrates with AWS and Stripe. These providers may access necessary data. We are not responsible for third-party practices.</p>

  <h3>9. Data Privacy</h3>
  <p>Data handling is governed by our Privacy Policy. By using our Platform, you consent to data collection and sharing.</p>

  <h3>10. Intellectual Property</h3>
  <p>All content and software are owned by Miracle Pace or licensors. No reproduction without permission.</p>

  <h3>11. Limitation of Liability</h3>
  <p>Miracle Pace is not liable for indirect, incidental, or consequential damages. Total liability is limited to payments made by you in the prior 12 months.</p>

  <h3>12. Disclaimer of Warranties</h3>
  <p>The Platform is provided "as is" and "as available."</p>

  <h3>13. Indemnification</h3>
  <p>You agree to indemnify Miracle Pace and affiliates from claims arising from violations or misuse.</p>

  <h3>14. Termination</h3>
  <p>We may suspend or terminate your access at any time. Upon termination, usage rights cease.</p>

  <h3>15. Governing Law</h3>
  <p>Ontario, Canada laws govern these Terms. Disputes resolved in Toronto courts.</p>

  <h3>16. Changes to These Terms</h3>
  <p>Updated versions posted on the website. Continued use constitutes acceptance.</p>

  <h3>17. Contact Us</h3>
  <p>Miracle Pace Inc.<br>
  1200 Bay Street, Suite 1201, Toronto, Ontario, Canada<br>
  Email: miraclepaceinc@outlook.com</p>
</div>
`;
